import { Global } from '@emotion/react';
import { resetStyles } from './resetStyles';
import { globalStyles } from './globalStyles';

export function GlobalStyles() {
  return <Global styles={[resetStyles, globalStyles]} />;
}
